import { coreInitiativesCommentsGetAsyncSlice } from './get';
import { CoreInitiativesCommentsName } from './name';
import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';
import { DeleteInitiativeCommentRequest } from '@api';

export const coreInitiativesCommentsRemoveSyncSlice = createRemoveCollectionSyncSlice({
	hasRequest: true,
	name: CoreInitiativesCommentsName,
	state: coreInitiativesCommentsGetAsyncSlice.asyncState,
	target: (request: DeleteInitiativeCommentRequest) => (comment) => comment.id === request.id
});
